export default {"src":"/_next/static/media/Technology.0880f2cf.svg","height":44,"width":44};